import ReactDOM from 'react-dom';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import App from './containers/App/App';
import ReactWarningTracker from './react-warning-tracker';
import ResizeObserverSuppressor from './resize-observer-suppressor';

// Uncomment to suppress the noisy ResizeObserver runtime error so CRA's overlay doesn't cover the UI
ResizeObserverSuppressor();

ReactWarningTracker();

ReactDOM.render(
  <ErrorBoundary name="root">
    <App />
  </ErrorBoundary>,
  document.getElementById('root'),
);
